import { Pipe, PipeTransform } from '@angular/core';
import { ExpertMemberLeanRecord, ExpertMemberRecord } from '@libs/shared/api';

@Pipe({
  name: 'expertMemberTitle',
  standalone: true,
})
export class ExpertMemberTitlePipe implements PipeTransform {
  transform(
    expertMember: ExpertMemberRecord | ExpertMemberLeanRecord
  ): unknown {
    return `${expertMember.lastName}${expertMember.firstName}`;
  }
}
